export default "__VITE_ASSET__D0j4_bwL__"